<template>
  <div class="">
    <el-container>
      <el-main>
        <el-form :inline="true" size="small">
          <el-form-item>
            <el-input v-model.trim="inputCardNumber" placeholder="请输入卡号" />
          </el-form-item>
          <el-form-item>
            <el-select v-model="lotteryStatus" placeholder="请选择状态" style="width: 200px">
              <el-option :value="0" label="未发货"></el-option>
              <el-option :value="1" label="已发货"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" plain type="primary" icon="el-icon-search" @click="search(1)">搜索</el-button>
          </el-form-item>
        </el-form>

        <el-table @selection-change="selectIdChange" ref="lotteryTable" :data="lotteryTableData"
                  :row-style="{height:'40px'}" :call-style="{height: '5px,0',textAlign:'center'}"
                  :header-cell-style="{background: '#f5f7fa', color: '#606266',textAlign:'center'}"
                    border style="width: 100%;margin-top: 1%;height: 70vh">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column prop="iccid" label="iccid" width="200" align="center"></el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170" align="center"></el-table-column>
          <el-table-column prop="address" label="收货地址" width="250" align="center">
            <template #default="scope">
              <el-tooltip :content="scope.row.address" raw-content placement="top-start" v-if="scope.row.address">
                <span v-if="scope.row.address && scope.row.address.length <= 15">
                  {{scope.row.address}}
                </span>
                <span v-if="scope.row.address&& scope.row.address.length > 15">
                  {{scope.row.address.substr(0, 15) + "..."}}
                </span>
              </el-tooltip>
              <span v-else-if="scope.row.address== null"> 无</span>
            </template>
          </el-table-column>
          <el-table-column prop="prize" label="奖品" width="130" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.prize === '0'">ipone13</div>
              <div v-if="scope.row.prize === '1'">5G流量</div>
              <div v-if="scope.row.prize === '2'">8G流量</div>
              <div v-if="scope.row.prize === '3'">ufi设备</div>
              <div v-if="scope.row.prize === '4'">键鼠</div>
              <div v-if="scope.row.prize === '5'">蓝牙耳机</div>
              <div v-if="scope.row.prize === '6'">小爱音箱</div>
              <div v-if="scope.row.prize === '7'">5G CPE设备</div>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机号" width="180" align="center"></el-table-column>
          <el-table-column prop="status" label="状态" width="180" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.status === '0'">未发货</div>
              <div v-if="scope.row.status === '1'">已发货</div>
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="180" align="center"></el-table-column>
          <el-table-column label="操作" min-width="200" align="center">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status==='0'" size="mini" @click="shipments(scope.row)">发货</el-button>
              <el-button v-if="scope.row.status==='1'" size="mini" >/</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination class="text-center" ref="pagination" v-bind:list="search" v-bind:itemCount="8"></pagination>
        <el-dialog :visible.sync="showShipments" :close-on-click-modal="false" title="填写快递单号" data-height="700">
          <el-form>
            <el-form-item>
              <el-input ref="numbers" v-model="numbers" placehoder="请输入快递单号"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="showShipments = false">取消</el-button>
            <el-button type="primary" @click="submitShipments('numbers')">确定</el-button>
          </div>
        </el-dialog>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import Pagination from '../../../components/pagination'

export default {
  name: 'lottery.vue',
  components: {
    Pagination
  },
  mounted: function () {
    let _this = this
    _this.$refs.pagination.size = 10
  },

  data() {
    return {
      lotteryInfo: {},
      inputCardNumber: '',
      lotteryStatus: '',
      address: '',
      lotteryTableData: [],
      showShipments: false,
      numbers: '',
      lotteryJs: require('../../../api/lottery')
    }
  },

  methods: {
    shipments(lottery) {
      this.lotteryInfo = lottery
      this.showShipments = true
    },

    search(page) {
      let data={
        current: page,
        size: this.$refs.pagination.size,
        iccid: this.inputCardNumber,
        status: this.lotteryStatus
      }
      this.lotteryJs.queryLotteryList(data)
        .then(res => {
          if (res.data.code === '0') {
            this.lotteryTableData = res.data.data.rows
            this.$refs.pagination.render(page, res.data.data.total)
          } else {
            this.$alert(res.data.msg)
          }
        })
        .catch(err => {
          alert('异常了')
        })
    },
    submitShipments(numbers) {
      this.lotteryInfo.numbers = this.numbers
      if (this.lotteryInfo.status === 1) {
        this.$message({
          type: 'error',
          message: '已是发货状态 无需发货'
        })
        this.showShipments = false
        return false
      }
      this.lotteryJs.shipments(this.lotteryInfo).then(res => {
        if (res.data.code === '0') {
          this.$alert(res.data.data)
          this.showShipments = false
          this.search(1)
        } else {
          this.$alert(res.data.msg)
          this.showShipments = false

        }
      })
    },
    selectIdChange(val) {
      let _this = this
      _this.multipleSelection = val
      let array = new Array()
      for (let i in _this.multipleSelection) {
        let section = _this.multipleSelection[i]
        let id = section.iccid
        array.push(id)
      }
      let str = array.join(',')
      _this.ids = str
    }
  }
}
</script>

<style lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
  .el-table__body-wrapper {
    height: calc(100% - 48px) !important; // 表格高度减去表头的高度
  overflow-y: auto;
  }
  }

/deep/.el-table .el-table__cell {
  padding: 0px;
}
/deep/thead.has-gutter {
  height: 40px;
}

</style>
